import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { productsQuery } from '../gql/products';
import { IProduct } from '../types/Product';
import { convertToPriceFormat } from '../utils/utils';

const useProducts = (categoryId?: string) => {
  const { loading, error, data } = useQuery(productsQuery(categoryId));
  const [products, setProducts] = useState<IProduct[]>([]);

  useEffect(() => {
    if (typeof data === 'object' && Object.values(data).length > 0) {
      const products = Object.values(data)[0] as IProduct[];
      const productsWithFormattedPrice = products.map((item) => {
        const formattedPrice = convertToPriceFormat(item.price);
        return { ...item, formattedPrice };
      });

      setProducts(productsWithFormattedPrice);
    }
  }, [data]);

  useEffect(() => {
    setProducts([]);
  }, [categoryId]);

  return { data: products, loading, error };
};

export default useProducts;
